import { render, staticRenderFns } from "./selectPoints.vue?vue&type=template&id=3ecac2b7&scoped=true"
import script from "./selectPoints.vue?vue&type=script&lang=js"
export * from "./selectPoints.vue?vue&type=script&lang=js"
import style0 from "./selectPoints.vue?vue&type=style&index=0&id=3ecac2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecac2b7",
  null
  
)

export default component.exports